import { FormControl, MenuItem } from "@mui/material";
import { UseFormRegister } from "react-hook-form";
import { FormState } from "react-hook-form/dist/types/form";
import { CreateCasesFormInput } from "~/pages/tickets/components/CreateTicketDialog/CreateTicketDialog";
import { CreateTicketNotesField } from "~/pages/tickets/components/CreateTicketDialog/CreateTicketNotesField";
import { CreateTicketTitleField } from "~/pages/tickets/components/CreateTicketDialog/CreateTicketTitleField";
import { CreateTicketServiceNowSelectField } from "~/pages/tickets/components/CreateTicketDialog/CreateTicketServiceNowSelectField";

interface CreateCaseModalProps {
  hasCreateCasePermissions: boolean;
  register: UseFormRegister<CreateCasesFormInput>;
  formState: FormState<CreateCasesFormInput>;
}

const impactOptions = [
  { value: 1, displayName: "1 - High" },
  { value: 2, displayName: "2 - Medium" },
  { value: 3, displayName: "3 - Low" },
];

const urgencyOptions = [
  { value: 1, displayName: "1 - High" },
  { value: 2, displayName: "2 - Medium" },
  { value: 3, displayName: "3 - Low" },
];

const priorityOptions = [
  { value: 1, displayName: "1 - Critical" },
  { value: 2, displayName: "2 - High" },
  { value: 3, displayName: "3 - Moderate" },
  { value: 4, displayName: "4 - Low" },
  { value: 5, displayName: "5 - Planning" },
];

export const CreateTicketServiceNowDialog = ({
  register,
  formState,
  hasCreateCasePermissions,
}: CreateCaseModalProps) => {
  return (
    <>
      <FormControl fullWidth sx={{ mb: 3 }}>
        <CreateTicketTitleField
          textFieldProps={register("servicenow.title", { required: true })}
          errorMessage={formState.errors?.servicenow?.title?.message}
          disabled={!hasCreateCasePermissions}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mb: 3 }}>
        <CreateTicketServiceNowSelectField
          title="Impact"
          errorMessage={formState.errors?.servicenow?.impact?.message}
          disabled={!hasCreateCasePermissions}
          defaultValue={3}
          registration={register("servicenow.impact", { valueAsNumber: true })}
        >
          {impactOptions.map((option) => (
            <MenuItem value={option.value} key={option.value}>
              {option.displayName}
            </MenuItem>
          ))}
        </CreateTicketServiceNowSelectField>
      </FormControl>

      <FormControl fullWidth sx={{ mb: 3 }}>
        <CreateTicketServiceNowSelectField
          title="Urgency"
          errorMessage={formState.errors?.servicenow?.urgency?.message}
          disabled={!hasCreateCasePermissions}
          defaultValue={3}
          registration={register("servicenow.urgency", { valueAsNumber: true })}
        >
          {urgencyOptions.map((option) => (
            <MenuItem value={option.value} key={option.value}>
              {option.displayName}
            </MenuItem>
          ))}
        </CreateTicketServiceNowSelectField>
      </FormControl>

      <FormControl fullWidth sx={{ mb: 3 }}>
        <CreateTicketServiceNowSelectField
          title="Priority"
          errorMessage={formState.errors?.servicenow?.priority?.message}
          disabled={!hasCreateCasePermissions}
          defaultValue={5}
          registration={register("servicenow.priority", {
            valueAsNumber: true,
          })}
        >
          {priorityOptions.map((option) => (
            <MenuItem value={option.value} key={option.value}>
              {option.displayName}
            </MenuItem>
          ))}
        </CreateTicketServiceNowSelectField>
      </FormControl>

      <FormControl fullWidth>
        <CreateTicketNotesField
          errorMessage={formState.errors.servicenow?.notes?.message}
          textFieldProps={register("servicenow.notes")}
          disabled={!hasCreateCasePermissions}
        />
      </FormControl>
    </>
  );
};
